jQuery( document ).ready(function() {
	// Check if component is added to the page
    if( jQuery('section.team-members').length ) {
        $teamModal = $('#teamModal');
        $modalClose = $('#teamModal .close');
        $modalContent = $('#teamModal .modal-body');
        $modalTitle = $('#teamModal .modal-header .name');

        $(".team-member-item.popup").click(function() {
            $teamModal.css("display", "flex").hide().fadeIn(1000);

            $_content = $(this).contents(".bio").html();
            $_name = $(this).find(".name").html();

            $modalContent.html( $_content );
            $modalTitle.html( $_name );
        });

        $(".team-member-item.page").click(function () {
            $url = $(this).data("page_link");
            window.location.replace($url);
        });


        $modalClose.click(function() {
            $teamModal.fadeOut(1000);
            $modalTitle.empty();
            $modalContent.empty();
        });

    }
});